import type { SuggestionChip, SuggestionChipSet } from '../state/chatTypes';

const QUESTION_CHIPS: ReadonlyArray<SuggestionChip> = [
  {
    id: 'idleLastWeek',
    translationKey: 'insights.sidekick.entry.questions.idleLastWeek',
  },
  {
    id: 'idlingTimeThisWeek',
    translationKey: 'insights.sidekick.entry.questions.idlingTimeThisWeek',
  },
  {
    id: 'utilizationsLastMonth',
    translationKey: 'insights.sidekick.entry.questions.utilizationsLastMonth',
  },
];

const ASK_SOMETHING_ELSE_INSIGHTS_KEY =
  'insights.sidekick.entry.questions.askSomethingElse';

export const MOCK_SIDEKICK_SUGGESTION_CHIP_SET: SuggestionChipSet = {
  questions: QUESTION_CHIPS,
  askSomethingElseLabel: ASK_SOMETHING_ELSE_INSIGHTS_KEY,
};

export const ASK_SOMETHING_ELSE_CHIP_ID = 'askSomethingElse';
